const docs = [
  {
    id: "download-binance",
    title: "如何下载币安 App",
    category: "交易所教程",
    content: `
# 如何下载币安 App

> 邀请码：**738205337**

---

## 安卓用户

点击主站链接，下载并安装即可：

- 免翻域名：https://www.bsmkweb.cc/join?ref=738205337

---

## iOS 苹果用户

下载地址：https://www.marketwebb.me/zh-CN/downloadTips

> **切换 ID 免翻域名**

:::warning
⚠️ **注意**：在大陆 AppStore 搜索到的币安 App 大概率是假的，**千万不要下载！**
:::

---

## 华为手机下载方式

**安装方式一**（推荐）：

https://download-1306379396.file.myqcloud.com/pack/Binance.apk

**安装方式二**：

1. 打开华为商城
2. 切换国家为「迪拜/英国」
3. 搜索「**Binance**」
4. 下载安装
![下载币安](/images/tutorials/download-binance-1.jpg)
`,
  },
  {
    id: "kyc-verification",
    title: "KYC 实名认证",
    category: "交易所教程",
    content: `
# 为什么要做 KYC 实名认证？

不完成 KYC，将受限于 **C2C 交易**、**Launchpad 参与**、**提币额度**等功能。

---

## 如何完成 KYC 实名认证？

### 手机端操作

1. 登录币安 App，点击左上角头像
2. 点击「认证」，进入身份验证流程
3. 上传身份证件 + 进行人脸识别

### 网页端教程

https://www.binance.com/zh-CN/support/faq/detail/360027287111

> 认证完成后即可解锁 C2C 交易与高额度功能。
![KYC认证](/images/tutorials/kyc-verification-1.jpg)
![KYC认证](/images/tutorials/kyc-verification-2.jpg)
`,
  },
  {
    id: "c2c-trading",
    title: "C2C 交易教程",
    category: "交易所教程",
    content: `
# C2C 交易教程

## 一、什么是 C2C 交易？

C2C 交易（又名法币交易）指使用 **人民币** 购买 / 出售数字货币。

官方介绍：https://www.binance.com/zh-CN/support/faq/%E4%B9%B0%E5%B8%81?c=66&navld=66#67-68

---

## 二、教学视频

**手机端买币教程**：https://www.binance.com/zh-CN/support/articles/360039384951

**网页端买币教程**：https://www.binance.com/zh-CN/support/articles/360043832851

---

## 三、C2C 交易付款注意事项

为了账户资金安全，务必遵守以下操作规范：

1. **已转账后不要点「取消交易」**，除非卖家已退款
2. **未付款不要点「确认付款」**，否则可能被冻结
3. **付款需手动进行**，点击「去支付」并不会自动转账
4. 若页面未显示卖家广告，请检查是否选择了 **【人民币 CNY】**

---

## 四、注册不满 7 天的用户提示

某些 C2C 商家设置了「注册时间门槛」，若遇无法交易情况，可以：

- 选择其他广告商
- 或使用「快捷区」进行「一键买币」

---

## 五、如何卖币提现成人民币？

**App 教程**：https://www.binance.com/zh-CN/support/faq/360039385091

**网页端教程**：https://www.binance.com/zh-CN/support/faq/360041106311

---

## 六、提现前必须等待 24 小时的原因

为防止资金冻结，购买加密资产后需 **等待 24 小时** 才能提现。
![C2C交易](/images/tutorials/c2c-trading-1.jpg)
`,
  },
  {
    id: "deposit-withdraw",
    title: "充值与提现",
    category: "交易所教程",
    content: `
# 充值与提现的方式

## 充值方式

除了 C2C 购买之外，也可将其他平台的加密资产充值到币安。

**数字货币充值与提现视频教学**：

https://www.binance.com/zh-CN/support/faq/%E5%85%85%E5%80%BC%E4%B8%8E%E6%8F%90%E5%B8%81%E6%96%B0%E6%89%8B%E6%8C%87%E5%BC%951-85a1c394ac1d489fb0bfac0ef2fceafd

> ⚠️ **注意**：大陆用户不支持充值法币，仅支持 C2C 买币充值。
![充值提现1](/images/tutorials/deposit-withdraw-1.jpg)
![充值提现2](/images/tutorials/deposit-withdraw-2.jpg)
`,
  },
  {
    id: "spot-trading",
    title: "现货交易实操",
    category: "交易所教程",
    content: `
# 现货交易实操教学

课程分为三部分：

1. 划转资产到现货账户
2. 币币现货交易
3. 设置止盈止损单

---

## 一、如何进行账户划转？

在使用人民币购买了 USDT 后，需将其从 **法币账户** 划转至 **现货账户** 才能用于币币交易。

**操作步骤：**

1. 打开 App 并登录账户
2. 点击「资金」标签，选择「C2C 账户」
3. 点击「转账」→ 选择「划转」
4. 设置转出账户、币种与金额，点击「划转」
5. 可点击右上角「历史」查看记录

---

## 二、币币现货交易操作指南

**币币交易**：使用一种数字货币（如 USDT）购买另一种币（如 BTC、ETH 等）

**视频教程：**

- 币币交易操作步骤：https://www.binance.com/zh-CN/support/articles/115003765031
- App 端操作教程：https://www.binance.com/zh-CN/support/faq/c0669862a9e743d781c067c14106c29a

### 交易手续费说明

可以在币安平台交易手续费页面查看详细费率。

### 挂单与吃单的区别

| 类型 | 说明 | 通俗理解 |
|---|---|---|
| **Maker（挂单）** | 订单以非市价挂入市场，等待他人成交 | "我 18U 买 BTC"，等别人来卖 |
| **Taker（吃单）** | 接受市场已有订单，立即成交 | 别人说"我 18U 卖 BTC"，你直接买了 |

---

## 三、止盈止损功能详解

**区别于普通限价单：**

- **限价单**：设好价格挂单，但可能因滑点或深度不足不成交
- **止盈止损单**：触发价 + 限价组合，当价格达到触发价才挂出订单，更灵活应对行情剧烈波动

**示例：**

当前价格 17U，设置触发价 18U 限价卖出，系统在达到 18U 时才挂单，避免错失波动时机。
![止盈止损](/images/tutorials/spot-trading-1.png)
`,
  },
  {
    id: "beginner-guide",
    title: "合约交易基础概念",
    category: "交易所教程",
    content: `
# 合约交易基础概念

合约交易的基础概念。

![合约交易1](/images/tutorials/contract-trading-1.png)
![合约交易2](/images/tutorials/contract-trading-2.jpg)
![合约交易3](/images/tutorials/contract-trading-3.jpg)
![合约交易4](/images/tutorials/contract-trading-4.jpg)
![合约交易5](/images/tutorials/contract-trading-5.jpg)
`,
  },
  {
    id: "grid-bot",
    title: "网格机器人",
    category: "交易所教程",
    content: `

# 网格机器人

![网格机器人1](/images/tutorials/grid-bot-1.jpg)
![网格机器人2](/images/tutorials/grid-bot-2.jpg)
![网格机器人3](/images/tutorials/grid-bot-3.jpg)
![网格机器人4](/images/tutorials/grid-bot-4.jpg)
`,
  },
  // ── 推荐书籍 ──────────────────────────────
  {
    id: "book-candlestick",
    title: "《日本蜡烛图技术》",
    category: "推荐书籍",
    author: "史蒂夫·尼森",
    content: `
# 《日本蜡烛图技术》

> 作者：史蒂夫·尼森（Steve Nison）

---

## 推荐理由

这是 K 线分析的**奠基之作**。作者首次将日本蜡烛图技术系统性地介绍给西方世界，书中的形态命名和解读方法至今仍是所有技术分析的基石。

适合想深入理解 K 线形态背后多空博弈逻辑的交易者。

---

## 适合人群

- 想系统学习 K 线形态的新手
- 希望提升图表阅读能力的进阶交易者

---

## 核心要点

1. **反转形态**：锤子线、吞没形态、乌云盖顶、启明星/黄昏星
2. **持续形态**：窗口、跳空、上升/下降三法
3. **蜡烛图与成交量**的配合验证
4. 如何在不同**时间周期**中应用蜡烛图
`,
  },
  {
    id: "book-technical-analysis",
    title: "《技术分析（金融市场技术分析）》",
    category: "推荐书籍",
    author: "约翰·墨菲",
    content: `
# 《金融市场技术分析》

> 作者：约翰·墨菲（John J. Murphy）

---

## 推荐理由

被称为技术分析的"**百科全书**"。全面覆盖趋势线、支撑压力、移动均线、振荡指标、波浪理论等所有经典技术分析方法，是入门技术分析必读的一本书。

---

## 适合人群

- 零基础想系统了解技术分析的交易者
- 需要一本工具书随时查阅的进阶者

---

## 核心要点

1. **道氏理论**与趋势基本概念
2. **图表形态**：头肩顶/底、双顶/底、三角形、矩形
3. **移动均线**与均线交叉策略
4. **震荡指标**：RSI、MACD、随机指标
5. **艾略特波浪**与**斐波那契**回撤
`,
  },
  {
    id: "book-trading-psychology",
    title: "《交易心理分析》",
    category: "推荐书籍",
    author: "马克·道格拉斯",
    content: `
# 《交易心理分析》

> 作者：马克·道格拉斯（Mark Douglas）

---

## 推荐理由

技术分析教你**怎么买**，这本书教你**怎么想**。大量交易者亏损不是因为策略不好，而是心态管理出了问题。这本书帮助你建立概率思维，克服恐惧和贪婪。

---

## 适合人群

- 总是拿不住单子、频繁止损的交易者
- 情绪化操作、追涨杀跌的人

---

## 核心要点

1. **概率思维**：接受每一笔交易的不确定性
2. **恐惧与贪婪**：识别情绪驱动的交易行为
3. **纪律性**：建立并遵守交易规则
4. **自我责任**：对自己的交易结果负责
`,
  },
  {
    id: "book-turtle-trading",
    title: "《海龟交易法则》",
    category: "推荐书籍",
    author: "柯蒂斯·费思",
    content: `
# 《海龟交易法则》

> 作者：柯蒂斯·费思（Curtis Faith）

---

## 推荐理由

揭秘了传奇交易员理查德·丹尼斯的"海龟实验"——用一套完整的趋势跟踪系统，将普通人训练成顶级交易员。书中不仅有策略，更有**资金管理**和**风险控制**的实战智慧。

---

## 适合人群

- 想学习趋势跟踪策略的交易者
- 对资金管理和仓位控制感兴趣的投资者

---

## 核心要点

1. **趋势跟踪**：突破入场的系统化方法
2. **ATR 仓位管理**：根据波动率动态调整仓位
3. **止损与止盈**：金字塔加仓与移动止损
4. **系统化交易**：规则化、去情绪化
`,
  },
  {
    id: "book-reminiscences",
    title: "《股票作手回忆录》",
    category: "推荐书籍",
    author: "埃德温·勒菲弗",
    content: `
# 《股票作手回忆录》

> 作者：埃德温·勒菲弗（Edwin Lefèvre）

---

## 推荐理由

以传奇交易员杰西·利弗莫尔为原型的半自传体小说。虽然写于 1923 年，但关于市场人性、持仓耐心、止损纪律的洞察至今完全适用。被誉为**交易领域的文学经典**。

---

## 适合人群

- 所有阶段的交易者（即使不炒股也值得读）
- 想理解市场心理和投机本质的人

---

## 核心要点

1. **耐心等待**最佳交易机会
2. **顺势而为**，不要逆势抄底
3. **止损是生存之本**
4. 市场的**人性不变**：恐惧与贪婪的循环
`,
  },
  {
    id: "book-bitcoin-standard",
    title: "《比特币本位》",
    category: "推荐书籍",
    author: "赛义德·阿莫斯",
    content: `
# 《比特币本位》

> 作者：赛义德·阿莫斯（Saifedean Ammous）

---

## 推荐理由

从货币史的角度解释了为什么比特币有价值。作者对比了贝壳、黄金、法币等不同货币体系，论证了比特币作为"**数字黄金**"的稀缺性和优越性。理解加密货币基本面必读。

---

## 适合人群

- 想理解比特币内在价值的投资者
- 对货币体系和经济学感兴趣的人

---

## 核心要点

1. **货币的演变**：从贝壳到黄金到法币
2. **稀缺性**：比特币 2100 万枚上限的意义
3. **去中心化**：为什么没有人能"印"比特币
4. **奥地利经济学**视角下的比特币
`,
  },
  // ── 财富认知 ──────────────────────────────
  {
    id: "wealth-mindset",
    title: "财富思维的底层逻辑",
    category: "财富认知",
    content: `
# 财富思维的底层逻辑

---

## 一、穷人思维 vs 富人思维

| 维度 | 穷人思维 | 富人思维 |
|---|---|---|
| 收入 | 靠时间换钱 | 靠资产和系统赚钱 |
| 消费 | 先消费再存钱 | 先投资再消费 |
| 风险 | 害怕风险，追求稳定 | 管理风险，拥抱不确定性 |
| 学习 | 离开学校就停止学习 | 终身学习，投资自己 |

---

## 二、财富的本质

财富不是工资的积累，而是**资产配置的结果**。

1. **主动收入**：工资、兼职 — 用时间换钱，有天花板
2. **被动收入**：投资回报、版税、租金 — 钱为你工作

真正的财务自由 = 被动收入 > 生活支出

---

## 三、关键认知转变

- 从"我买不起"到"我怎样才能买得起"
- 从"存钱是最安全的"到"通胀在侵蚀你的存款"
- 从"投资是赌博"到"不投资才是最大的风险"
`,
  },
  {
    id: "inflation-and-crypto",
    title: "通货膨胀与加密货币",
    category: "财富认知",
    content: `
# 通货膨胀与加密货币

---

## 一、什么是通货膨胀？

通货膨胀是指货币供应量增加，导致**购买力下降**、物价上涨的经济现象。

简单理解：同样的 100 块钱，10 年前能买一车东西，现在只能买半车。

---

## 二、通胀对普通人的影响

1. **存款贬值**：银行里的钱实际在缩水
2. **工资增长跟不上物价上涨**
3. **资产价格飙升**：房价、股票、黄金越来越贵

---

## 三、为什么加密货币是对抗通胀的工具？

| 特性 | 法币 | 比特币 |
|---|---|---|
| 发行量 | 无上限，央行可超发 | 总量 2100 万枚，不可增发 |
| 透明度 | 不透明 | 公开可验证 |
| 抗审查 | 受银行控制 | 去中心化，无人可控 |

比特币的**固定供应量**使其成为数字时代的"稀缺资产"，类似黄金在传统金融中的角色。

---

## 四、理性看待

加密货币是对抗通胀的**工具之一**，不是唯一答案。合理的资产配置应该多元化。
`,
  },
  {
    id: "asset-allocation",
    title: "资产配置入门",
    category: "财富认知",
    content: `
# 资产配置入门

---

## 一、为什么资产配置很重要？

> "不要把所有鸡蛋放在一个篮子里。"

资产配置决定了你 90% 的投资回报，选股和择时只占 10%。

---

## 二、常见资产类别

| 资产类型 | 风险等级 | 收益预期 | 适合人群 |
|---|---|---|---|
| 银行存款 | 极低 | 低 | 保守型 |
| 国债/债券 | 低 | 中低 | 稳健型 |
| 指数基金 | 中 | 中 | 长期投资者 |
| 股票 | 中高 | 中高 | 有经验的投资者 |
| 加密货币 | 高 | 高 | 风险承受能力强 |
| 房产 | 中 | 中 | 资金充裕者 |

---

## 三、新手推荐的配置比例

- **应急资金**（3-6 个月生活费）：银行存款 / 货币基金
- **稳健部分**（60-70%）：指数基金 + 债券
- **增长部分**（20-30%）：股票 + 加密货币
- **投机部分**（0-10%）：高风险投资

---

## 四、核心原则

1. **先保障再投资**：有应急资金后再考虑投资
2. **分散投资**：不同资产类别、不同市场
3. **定期调整**：每年至少审视一次资产配置
4. **长期持有**：时间是复利的朋友
`,
  },
  {
    id: "risk-management",
    title: "风险管理基础",
    category: "财富认知",
    content: `
# 风险管理基础

---

## 一、什么是风险管理？

风险管理就是在追求收益的同时，**控制可能的损失**。

> 投资第一法则：不要亏钱。 —— 沃伦·巴菲特

---

## 二、常见风险类型

1. **市场风险**：价格波动导致的亏损
2. **流动性风险**：想卖的时候卖不出去
3. **信用风险**：对手方违约
4. **操作风险**：人为失误（如转账错误）
5. **黑天鹅事件**：不可预测的极端事件

---

## 三、实用的风险管理方法

### 仓位管理
- 单笔投资不超过总资金的 **5-10%**
- 加密货币总投资不超过可承受损失的金额

### 止损策略
- 设定明确的止损线（如亏损 15% 止损）
- 不要心存侥幸"等它回来"

### 分批建仓
- 不要一次性全仓买入
- 分 3-5 次建仓，降低平均成本

### 对冲
- 通过不同资产的对冲来降低整体风险

---

## 四、心态管理

- 不要用借来的钱投资
- 不要追涨杀跌
- 亏损后不要急于翻本
- 制定计划，严格执行
`,
  },
];

export default docs;
